import { StrictMode } from 'react';

import ReactDOM from 'react-dom';
import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';
// import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

// Configure error handling for moment.js locale loading errors
// This prevents the "Cannot find module './en'" error from breaking the app
// The error occurs when moment.js tries to dynamically load locale files that aren't bundled
if (typeof window !== 'undefined') {
  // Catch unhandled promise rejections that might be from moment locale loading
  const originalOnError = window.onerror;
  window.onerror = function (message, source, lineno, colno, error) {
    // Suppress moment locale loading errors
    if (
      typeof message === 'string' &&
      (message.includes("Cannot find module './en'") ||
        (message.includes('Cannot find module') && message.includes('locale')))
    ) {
      console.warn('Suppressed moment locale loading error:', message);
      return true; // Suppress the error
    }

    // Call original error handler for other errors
    if (originalOnError) {
      return originalOnError.call(this, message, source, lineno, colno, error);
    }
    return false;
  };

  // Also catch unhandled promise rejections
  window.addEventListener('unhandledrejection', function (event) {
    const reason = event.reason;
    if (
      reason &&
      typeof reason === 'object' &&
      reason.message &&
      (reason.message.includes("Cannot find module './en'") ||
        (reason.message.includes('Cannot find module') &&
          reason.message.includes('locale')))
    ) {
      console.warn(
        'Suppressed moment locale loading promise rejection:',
        reason.message
      );
      event.preventDefault(); // Prevent the error from being logged
    }
  });
}

// Service worker
import * as serviceWorker from './common/serviceWorker';

// App
import App from './App';
import AppConfig from './config';

ReactDOM.render(
  <StrictMode>
    <App />
  </StrictMode>,
  document.getElementById('root')
);

if (AppConfig.IS_DEV_BUILD) {
  // firebase.auth().useEmulator('http://localhost:9099/');
  // firebase.firestore().useEmulator('localhost', 8080);
} else {
  // Initialize LogRocket
  LogRocket.init('bb1y0p/e-english');
  setupLogRocketReact(LogRocket);
}

// console.log(
//   `%c${AppConfig.buildId}`,
//   'font-size: 2em; font-weight: 800',
//   `\n${JSON.stringify(AppConfig, null, 2)}`
// );

// Initialize the service worker
serviceWorker.unregister();
